import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { awsSortedAccountsSelector } from "./awsSortedAccountsSelector";
import { nonDeletedAndNotBillingAccountsCombiner } from "../../combiners/nonDeletedAndNotBillingAccountsCombiner";

export const awsNonDeletedAndNotBillingAccountsSelector =
  createDraftSafeSelector(
    [awsSortedAccountsSelector],
    nonDeletedAndNotBillingAccountsCombiner,
  );
